import Vue from 'vue';
import VueRouter from 'vue-router';
import { getURLSearchParams } from '@/utils/utils';
Vue.use(VueRouter);

const routes = [
  {
    path: '/information/index',
    name: 'informationIndex',
    component: () => import('@/sub-app/information/pages/index.vue'),
    meta: {
      title: '活动资讯',
      keepAlive: true,
    },
  },
  {
    path: '/information/list',
    name: 'informationList',
    component: () => import('@/sub-app/information/pages/list.vue'),
    meta: {
      title: '资讯',
      keepAlive: true,
    },
  },
  {
    path: '/information/informationDetail',
    name: 'informationDetail',
    component: () => import('@/sub-app/information/pages/informationDetail.vue'),
    meta: {
      title: '详情',
      keepAlive: false,
    },
  },
  {
    path: '/information/search',
    name: 'informationSearch',
    component: () => import('@/sub-app/information/pages/search.vue'),
    meta: {
      title: '搜索',
      keepAlive: true,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  let title = to.meta?.title || '';
  const urlParams = getURLSearchParams();
  if (urlParams && urlParams.title) {
    title = decodeURIComponent(urlParams.title);
  }
  document.title = title;
  next();
});

export default router;
